//Отображение добавленных ингредиентов в формае добавления ингредиентов

import React from 'react';
import {process} from '../../../constants/constants'
import { useSelector} from 'react-redux'
import { SelectEdit} from '../../molecules'
import { Popup} from '../../organisms'

export function AddListIng(props) {
  const item = props.item 
  const {ingredients, status} = useSelector(state => state.ingredients)
  const ingBase = ingredients.find(i=> i._id ===item._id)
  const  thermoself = process.find(i=> i.nameEn === item.thermoself ) // Поиск для показа руского наименования
  const [showEventList, setshowEventList] = React.useState(false)
  const eventRef = React.useRef()
 
  React.useEffect(() => {
    const click = e => {
      if (showEventList && eventRef.current && !eventRef.current.contains(e.target)  ) {
        setshowEventList(false)
      }
    }
    document.addEventListener("mousedown", click)
    return () => {
      document.removeEventListener("mousedown", click)
    }
  }, [showEventList])  

  function handleEdit(value) { 
    setshowEventList(false)
    props.onChange(value, item)
   }
   const errorKey = `weight${props.index}`;
   const errorValue = props.error[errorKey]; 
 
   const showCloseEvents = () => {  
    setshowEventList(!showEventList)
  }
 
 

  return ( 
    <div className='form__data_ingredient'>
      <p className='form__item_title font20Norm'>{item.ingredients === undefined ? ingBase.name : item.ingredients}</p>
      <label className='form__label_ing font20Norm'>
        <input
          type="number"
          id={`weigth${props.index}`}
          name={`weigth${props.index}`}
          value={item.weight || ''}
          onChange={(e) => props.handleWeightChange(item._id, e.target.value, item.group, props.index)} 
          max='1000'
          min='0,001'
          placeholder="0"
          className={`form__input_time font20Norm ${errorValue ? 'form__input_error' : ''}`}
        />  
        {item.choisMeasure}
        {errorValue && <span className="form__text_error font14Norm">{errorValue}</span>}
      </label> 
      <div className='form__data_ingredient_process'>
      <div className='p-m-l font20Norm'> 
     <label className='form__label_group font20Norm'>  
     
        <Process
          onClick={handleEdit} 
          unit={process}
          thermoself={thermoself}
          showCloseEvents={showCloseEvents}
          showEventList={showEventList}
          eventRef={eventRef}
          
        />
   </label>
     </div>
    
      <button type='button' className='gg-delete m-size' onClick={()=>props.handleDelete(item._id, item.group)}/>
      </div>
    </div>
  )        
}
  
const Process = (props) => { 
 
  return(
    <div className='hours__select'>
      <div className='hours__select_visible  '>
        <p className={`${!props.thermoself ? 'hours__unit_paccive': 'hours__unit'}`} onClick={props.showCloseEvents} > {props.thermoself ? props.thermoself.nameRu : 'Обработка'}</p>
       
    </div>
    <Popup isOpen={props.showEventList} ref={props.eventRef} type='hours' >
      {props.unit.map((el, index) => <span  key={index} className="form__span_time font20Norm colorGrey" onClick={()=> props.onClick(el)}>{el.nameRu}</span>)}
    </Popup> 
  </div>
  )
}